import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b6452bfc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6452bfc')) {
      api.createRecord('b6452bfc', component.options)
    } else {
      api.reload('b6452bfc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b6452bfc&", function () {
      api.rerender('b6452bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xx73rc6ZHze/JS/offershelp.vue"
export default component.exports